import { getJobs, getJob, editJob, createJob, postToBoard, cancelJob, approveJob, getPayCostRate, addTipsToWorkers,
  employerRateWorkers, createMultiJob, approveMultiDayJob, unApproveJob, notifyJob } from '../api';
import { dispatchErrorAction } from './index';
import * as actionTypes from './actionTypes';
import { formatJobsList, formatJobDetails } from '../helpers/fromServer';
import { JOBS_LIST_PAGE_SIZE } from '../constants/general';
import { getPagesCount } from '../helpers/general';

export function getAllJobs (skip = 0, data) {
  return dispatch => getJobs(skip, data)
    .then(({ data }) => {
      const pagesQuantity = getPagesCount(data.count, JOBS_LIST_PAGE_SIZE);
      dispatch({
        type: actionTypes.GET_ALL_JOBS_SUCCESS,
        jobsList: formatJobsList(data.data),
        pagesQuantity,
        pastJobsWarning: !!data.pastJobsWarning // FIXME: in server response pastJobsWarning is equal 1, need to be changed to bool value
      });
      return data.data;
    })
    .catch(error => {
      dispatchErrorAction(error, dispatch);
    });
}

export function getJobDetails (id) {
  return dispatch => getJob(id)
    .then(({ data }) => {
      const jobDetailsData = formatJobDetails(data);
      dispatch({ type: actionTypes.GET_JOB_DETAILS_SUCCESS, payload: jobDetailsData });
      console.log(jobDetailsData);
      return jobDetailsData;
    })
    .catch(error => {
      dispatchErrorAction(error, dispatch);
    });
}

export function clearJobDetails () {
  return dispatch => dispatch({ type: actionTypes.CLEAR_JOB_DETAILS });
}

export function editJobAction (id, jobData) {
  return dispatch => editJob(id, jobData)
    .then(({ data }) => {
      dispatch({ type: actionTypes.EDIT_JOB_SUCCESS, payload: data });
      return data;
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function createJobAction (jobData) {
  return dispatch => createJob(jobData)
    .then(({ data }) => {
      dispatch({ type: actionTypes.CREATE_JOB_SUCCESS, payload: data });
      return data;
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function createMultiDayJob (jobData) {
  return () => createMultiJob(jobData)
    .then(({ data }) => {
      return data;
    })
    .catch(error => error.response.data);
}

/**
 *
 * @param {number[]} jobs
 * @param {boolean} post_to_board
 *
 * */
export function postToBoardAction (jobs, post_to_board) {
  return dispatch => postToBoard(jobs, post_to_board)
    .then(data => {
      dispatch({ type: actionTypes.POST_JOB_SUCCESS, post_to_board });
      return data;
    })
    .catch(error => error.response.data);
}

export function cancelJobAction (jobId, userRole) {
  return dispatch => cancelJob(jobId, userRole)
    .then(() => {
      dispatch({ type: actionTypes.CANCEL_JOB_SUCCESS });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function approveJobAction (id, signatureUrl) {
  return dispatch => approveJob(id, signatureUrl)
    .then(() => {
      dispatch({ type: actionTypes.APPROVE_JOB_SUCCESS });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function sendJobNotificationAction (jobId, userRole) {
  return dispatch => notifyJob(jobId, userRole)
    .then(() => {
      dispatch({ type: actionTypes.SEND_JOB_NOTIFICATION });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function approveMultiDayJobAction (eventId, signatureUrl) {
  return dispatch => approveMultiDayJob(eventId, signatureUrl)
    .then(({ data }) => data)
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function unApproveJobAction (id) {
  return dispatch => unApproveJob(id)
    .then(({ data }) => data)
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function getPayCostRateAction (data) {
  return dispatch => {
    dispatch({ type: actionTypes.GET_COST_PAY_RATE_START });
    return getPayCostRate(data)
      .then(({ data }) => {
        dispatch({ type: actionTypes.GET_COST_PAY_RATE_SUCCESS, costPayRateList: data });
        return data;
      })
      .catch(error => {
        dispatch({ type: actionTypes.GET_COST_PAY_RATE_ERROR });
        dispatchErrorAction(error, dispatch);
      });
  };
}

export function addTipsToWorkersAction (jobId, formData) {
  return dispatch => {
    return addTipsToWorkers(jobId, formData)
      .catch(error => {
        dispatchErrorAction(error, dispatch);
      });
  };
}

export function rateWorkersAction (jobId, formData) {
  const data = {
    rehire: false,
    ...formData
  };

  return dispatch => {
    return employerRateWorkers(jobId, data)
      .catch(error => {
        dispatchErrorAction(error, dispatch);
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/jobs.js